//单站概览
const stationOverviewEn = {
  staOverLang: {
    请输入站点名称搜索: 'Please enter the station name',
    暂无数据: 'No data available',
    创建电站: 'Create a power station',
    今日充电量: 'Charging data/Today',
    较昨日下降: 'Compared to yesterday',
    较昨日增长: 'Compared to yesterday',
    月充电: 'Monthly',
    累计充电: 'Accumulated',
    今日放电量: 'Discharge data/Today',
    月放电: 'Monthly',
    累计放电: 'Accumulated',
    今日收益: 'Income for the day',
    元: '',
    本月收益: 'Monthly income',
    万元: 'K',
    总收益: 'Total revenue',
    发生中告警: 'Alarm in progress',
    条: ' ',
    查看详细: 'Details',
    运维处理: 'O&M handling',
    无需关注: 'No need to care',
    站点信息: 'Site information',
    暂无站点图片: 'No site pictures',
    点击上传: 'Click to upload',
    装机总容量: 'Total installed capacity',
    装机功率: 'Installed power',
    投运时间: 'Operation time',
    电站地址: 'Address',
    查看电站: 'View power station',
    基础信息: 'Basic information',
    更多信息: 'More information',
    电站图片: 'Picture of the power station',
    装机容量: 'Installed capacity',
    电站联系电话: 'Power station contact number',
    安装图片: 'Equipment installation pictures',
    并网点信息: 'Consolidation point information',
    有光伏: 'Photovoltaic',
    无光伏: 'No photovoltaics',
    有并网点: 'Parallel branch',
    无并网点: 'No branch',
    其它: 'Others',
    变压器信息: 'Transformer information',
    站点变压器容量: 'Station transformer capacity',
    安装人: 'Installer',
    安装人联系号码: 'Installer Contact Number',
    关闭: 'Close',
    综合效率: 'Overall efficiency',
    '指单位时间内的电站放电量 ÷ 充电量': 'refer to the power station discharge ÷ charging amount per unit time.',
    近7日: 'Last 7 days',
    近31日: 'Last 31 days',
    近12月: 'Last 12 months',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    放电达成率: 'Discharge completion rate',
    '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数':
      'Discharge completion rate: refer to the discharge capacity of the power station per unit time ÷ (installed capacity ×  Discharge days ). Discharge days: refer to the number of days when the actual discharge is greater than 0.',
    本周: 'This week',
    本月: 'This month',
    本年: 'This year',
    收益统计: 'Revenue statistics',
    充放电统计: 'Electricity statistics',
    收益: 'Income',
    系统列表: 'System list',
    通讯状态: 'Communication Status',
    全部: 'All',
    在线: 'Online',
    离线: 'Offline',
    请输入内容: 'Please enter content',
    查询: 'Query',
    重置: 'Reset',
    导出: 'Export',
    系统编号: 'System number',
    系统名称: 'System name',
    在线状态: 'Online status',
    今日充放电量: 'Charging/discharging capacity today',
    累计充放电量: 'Accumulated charging/discharging capacity',
    运维处理今日: 'O&M processing(Today)',
    电网有功功率: 'Active power of the power grid',
    储能有功功率: 'Energy storage active power',
    负载有功功率: 'Load active power',
    序号: 'Serial Number',
    请选择站点: 'Please select a site'
  }
}
export default stationOverviewEn
